import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Card, Input, List, Popover, Popconfirm, Typography } from 'antd'
import { Check, Edit, Plus, X } from 'react-feather'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { DisabledRelations } from 'Model'
import { setDisabledRelations } from 'Actions/explore'
import { showGenericErr } from './helpers'
import WeaverService from 'Services/WeaverService'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    <Text code>disabledRelations</Text> are used to determine which <Text mark>relations</Text> to ignore within a project.
    Multiple <Text code>disabledRelations</Text> can be configured.
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Disabled Relations'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

DisabledRelationsPanel = ({ disabledRelations, setDisabledRelations }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [node, setNode] = useState(undefined)
  [dataArray, setDataArray] = useState(_.uniq(disabledRelations))
  [disabledRelation, setDisabledRelation] = useState(undefined)
  [error, setError] = useState(undefined)


  useEffect( ->
    ( ->
      node = await DisabledRelations.load()
      setNode(node)
      setLoading(false)
    )()
    undefined
  , [])

  actions = (
    if isEditing
      [
        <Button
          type="text"
          onClick={ ->
            try
              await node.update(dataArray)
              setDisabledRelations(dataArray)
            catch
              showGenericErr()
            setIsEditing(false)
          }
        >
          <Check />
        </Button>
        <Button
          type="text"
          onClick={ ->
            try
              setDataArray(node.list())
            catch
              showGenericErr()
            setIsEditing(false)
          }
        >
          <X />
        </Button>
      ]
    else
      [
        <Button
          type="text"
          disabled={!WeaverService.userCanEdit()}
          onClick={ -> setIsEditing(true)}
        >
          <Edit />
        </Button>
      ]
  )

  <Card
    title="Disabled Relations"
    loading={loading}
    actions={actions}
    extra={info}
    size="small"
    id="Disabled relations"
  >
    <List
      dataSource={ dataArray }
      renderItem={(item) -> (
        <List.Item
          actions={
            [
              <Popconfirm
                title="Are you sure to delete #{item}?"
                onConfirm={->
                  try
                    filteredArr = dataArray.filter((_item) -> _item isnt item)
                    await node.update(filteredArr)
                    setDataArray(filteredArr)
                    setDisabledRelations(filteredArr)
                  catch
                    showGenericErr()
                }
                okText="Yes"
                cancelText="No"
              >
                <a key="disabled-relation-delete-#{item}">delete</a>
              </Popconfirm>
            ]
          }
        >
          <div>{item}</div>
        </List.Item>
      )}
    />
    {
      if isEditing
        <div>
          <Input
            value={disabledRelation}
            onChange={({ target: { value }}) ->
              setError(undefined)
              setDisabledRelation(value)
            }
            style={{ width: '80%' }}
            placeholder="Enter the name of the relation you wish to disable"
          />
          <Button
            icon={<Plus style={{ height: 16, position: 'relative', top: 3 }} />}
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={ ->
              if disabledRelation?
                return setError('There is already a disabled relation with that value.') if dataArray.indexOf(disabledRelation) > -1
                setDataArray([dataArray..., disabledRelation])
                setDisabledRelation(undefined)
            }
          >
            Add
          </Button>
          <br/>
          <Text type="danger" style={{ marginLeft: 5 }}>{ error }</Text>
        </div>
      }
  </Card>

export default connect(({ explore }) ->
  { disabledRelations: explore.disabledRelations }
, { setDisabledRelations })(DisabledRelationsPanel)
